/* globals $ */
import { registerClass } from 'libs/ComponentLoader'

import './styles.scss'

class StyleGuide {
  constructor (element) {
    this.$el = $(element)
  }
}

registerClass('StyleGuide', StyleGuide)
